import React, { useEffect, useRef, useState } from "react";

const FRAME_W = 1440;

export const liveHost = (url) => {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
};

const LiveSiteFrame = ({ url, image, name, compact = false }) => {
  const stageRef = useRef(null);
  const frameH = compact ? 720 : 900;
  const [scale, setScale] = useState(compact ? 0.35 : 0.5);
  const [showLive, setShowLive] = useState(false);
  const [iframeOn, setIframeOn] = useState(false);

  useEffect(() => {
    const el = stageRef.current;
    if (!el) return;

    const syncScale = () => {
      const w = el.getBoundingClientRect().width;
      if (w) setScale(w / FRAME_W);
    };

    syncScale();
    const ro = new ResizeObserver(syncScale);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  useEffect(() => {
    const el = stageRef.current;
    if (!el || !url) return undefined;

    const mq = window.matchMedia("(min-width: 1024px)");
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && mq.matches) setIframeOn(true);
      },
      { rootMargin: "240px" }
    );

    const onMq = () => {
      if (!mq.matches) setIframeOn(false);
    };

    io.observe(el);
    mq.addEventListener("change", onMq);
    return () => {
      io.disconnect();
      mq.removeEventListener("change", onMq);
    };
  }, [url]);

  return (
    <div className={`work-browser ${compact ? "is-compact" : ""}`}>
      <div className="work-chrome">
        <span className="hero-dots" aria-hidden="true">
          <i />
          <i />
          <i />
        </span>
        <span className="work-url">{url ? liveHost(url) : name}</span>
        {url ? (
          <span className="work-live">
            <i />
            Live
          </span>
        ) : null}
      </div>

      <div
        ref={stageRef}
        className="work-stage"
        style={{ height: Math.max(compact ? 160 : 220, frameH * scale) }}
      >
        <img
          src={image}
          alt={`${name} website`}
          className={`work-fallback ${showLive ? "is-hidden" : ""}`}
        />

        {iframeOn && url ? (
          <iframe
            title={`${name} live site`}
            src={url}
            className={`work-iframe ${showLive ? "is-on" : ""}`}
            style={{
              width: FRAME_W,
              height: frameH,
              transform: `scale(${scale})`,
            }}
            loading="lazy"
            referrerPolicy="no-referrer"
            onLoad={() => setShowLive(true)}
          />
        ) : null}
      </div>
    </div>
  );
};

export default LiveSiteFrame;
